import React from 'react'
import PropTypes from "prop-types";
import { propTypes } from 'react-bootstrap/esm/Image';


function P2EServiceCard(props) {
  return (
    <div onClick={props.onClick} className='polymer-p2eservice-card' style={props.style}>
      <div className='polymer-p2eservice-card__rect'/>
      <div className='polymer-p2eservice-card__title' style={{fontSize: props.fontSize}}>
        {props.title}
      </div>
      <div className='polymer-p2eservice-card__icon'>
        {props.icon}
      </div>
    </div>
  )
}

export default P2EServiceCard


P2EServiceCard.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  fontSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ]),
  onClick: PropTypes.func,
  style: PropTypes.object
}


P2EServiceCard.defaultProps = {
  title: "Conversion Scheme",
  fontSize: 18,
  icon: <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" alt='Flat icon'>
  <path d="M40 76C59.8823 76 76 59.8823 76 40C76 20.1177 59.8823 4 40 4C20.1177 4 4 20.1177 4 40C4 59.8823 20.1177 76 40 76Z" fill="#EFF8FA"/>
  <path d="M44.6155 22.4922H23.9395V59.6798H44.6155V22.4922Z" stroke="#323232" style={{strokeWidth: "1.4", strokeMiterlimit: "10"}}/>
  <path d="M56.6773 59.6785H44.6172V32.2266L56.6773 38.5943V45.4486V59.6785Z" stroke="#323232" style={{strokeWidth: "1.4", strokeMiterlimit: "10"}}/>
  <path d="M31.3427 34.5781H27.5V38.4198H31.3427V34.5781Z" fill="#FFC524"/>
  <path d="M37.5068 34.5781H33.6641V38.4198H37.5068V34.5781Z" fill="#0C8188"/>
  <path d="M31.3427 27.3984H27.5V31.2402H31.3427V27.3984Z" fill="#0C8188"/>
  <path d="M37.5068 27.3984H33.6641V31.2402H37.5068V27.3984Z" fill="#FFC524"/>
  <path d="M50.0008 49H47V52H50.0008V49Z" fill="#0C8188"/>
  <path d="M54.5926 49H51.5918V52H54.5926V49Z" fill="#0C8188"/>
  <path d="M50.0008 44H47V47H50.0008V44Z" fill="#0C8188"/>
  <path d="M54.5926 44H51.5918V47H54.5926V44Z" fill="#0C8188"/>
  <path d="M31.3427 41.2031H27.5V45.0448H31.3427V41.2031Z" fill="#0C8188"/>
  <path d="M37.5068 41.2031H33.6641V45.0448H37.5068V41.2031Z" fill="#FFC524"/>
  <path d="M31.3427 47.8359H27.5V51.6777H31.3427V47.8359Z" fill="#0C8188"/>
  <path d="M37.5068 47.8359H33.6641V51.6777H37.5068V47.8359Z" fill="#0C8188"/>
  <path d="M40.9922 56.0903V25.9337L42.0153 24.2109V56.0903H40.9922Z" fill="#0C8188"/>
  </svg>
  ,
};
